import { defaultPitch } from './pitch'
import { pitchSetupTypes } from '../../pitches/data_types'

export const demonstrationProps = {
  reportMetricConfig: {
    playerPerformanceTable: {
      all: {
        metrics: {
          keys: []
        },
        eventMetricGroup: {
          eventTypes: [],
          groupName: {
            en: 'Success %',
            fr: 'Succès %'
          }
        }
      }
    },
    playerComparisonTable: {
      pass: {
        metrics: [[], [], []]
      }
    },
    monitoringCards: {
      technicalMetrics: [],
      physicalMetrics: []
    },
    dashboardMetrics: {
      performanceAgainstAverage: [],
      cardGrid: [[], []]
    }
  },
  pitch: {
    default: defaultPitch,
    defaultDoublePitch: null,
    pitchPointCount: 4,
    setupTypes: pitchSetupTypes,
    minPadding2D: 70,
    minPadding3D: 50,
    cameraYScale: 0.5,
    textureCanvasScale: 11,
    enableBench: true,
    enabled2DCameraControls: true,
    leftTeamRegion: {
      topLeft: 'P1',
      topRight: 'P1',
      bottomRight: 'P2',
      bottomLeft: 'P2'
    },
    rightTeamRegion: {
      topLeft: 'P3',
      topRight: 'P3',
      bottomRight: 'P4',
      bottomLeft: 'P4'
    },
    leftAutosetupRegion: {
      topLeft: null,
      topRight: null,
      bottomRight: null,
      bottomLeft: null
    },
    rightAutosetupRegion: {
      topLeft: null,
      topRight: null,
      bottomRight: null,
      bottomLeft: null
    },
    pitchCornerKeys: {
      topLeft: null,
      topRight: null,
      bottomRight: null,
      bottomLeft: null
    },
    autosetupTagPositions: []
  },
  features: {
    targetEvents: [],
    positionNumbers: false,
    maxPlayers: 50,
    defaultUnitSystem: 'SI',
    keyboardShortcuts: {},
    recentEventTableMetrics: [],
    geniusAvailable: false,
    noOfPlayersInStartingLineUp: null,
    scoreboard: false,
    homeSideCheck: false,
    bibs: {},
    defaultBibTeamDirection: [] as number[],
    disableAsSessionType: true
  } as const
}

export const demonstrationConfig = {
  key: 'demonstration' as const,
  value: 'Demonstration' as const,
  name: 'Demonstration',
  props: demonstrationProps
}
